var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"title":"预览","width":1080,"visible":_vm.visible,"okText":"打印","confirmLoading":_vm.loading},on:{"ok":_vm.handleOk,"cancel":() => { _vm.$emit('cancel') }}},[_c('div',{staticClass:"printwrap"},[_c('div',{attrs:{"id":"printMe"},domProps:{"innerHTML":_vm._s(_vm.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }